import { useMutation } from '@tanstack/react-query';
import { queryClient } from 'src/components/queryProvider';
import { IClone } from 'src/interfaces';
import { lang } from 'src/utils';
import { improvedFailedToError } from 'src/utils/improvedFailedToError';
import { queryKeys } from 'src/utils/queryKeys';

import { requestCCApi } from '../../../utils/axios-utils';

export const useClone = (showSnackbarError = true) => {
  return useMutation({
    mutationFn: (payload: IClone) => cloneResource(payload, showSnackbarError),
    onSuccess: (data, payload) => {
      if (payload.type === 'component') {
        queryClient.invalidateQueries(queryKeys.components.invalidateAll());
      } else if (payload.type === 'assembly') {
        queryClient.invalidateQueries(
          queryKeys.assemblyListing.invalidateAll(),
        );
      } else if (payload.type === 'location-group') {
        queryClient.invalidateQueries(queryKeys.locationGroups.invalidateAll());
      }
    },
  });
};

const cloneResource = async (payload: IClone, showSnackbarError = true) => {
  const response = await requestCCApi(
    {
      url: `/clone`,
      method: 'POST',
      data: payload,
    },
    showSnackbarError,
    improvedFailedToError(lang.update, lang.componentName),
  );

  return response;
};
